import { FormEvent, useMemo, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";

import { APP_NAME } from "../constants/brand";
import { verifyEmail } from "../services/api";

export function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [message, setMessage] = useState("Inserisci il codice OTP ricevuto via email.");
  const [otp, setOtp] = useState("");

  const email = searchParams.get("email");
  const token = searchParams.get("token");
  const linkValid = useMemo(() => Boolean(email && token), [email, token]);

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    if (!linkValid || !email || !token) {
      setStatus("error");
      setMessage("Link non valido. Apri il link completo ricevuto via email.");
      return;
    }
    if (!/^\d{6}$/.test(otp.trim())) {
      setStatus("error");
      setMessage("Inserisci un codice OTP numerico di 6 cifre.");
      return;
    }

    setStatus("loading");
    try {
      const result = await verifyEmail({ email, token, otp: otp.trim() });
      setStatus("success");
      setMessage(result.message);
    } catch (err) {
      setStatus("error");
      setMessage(err instanceof Error ? err.message : "Verifica email non riuscita");
    }
  }

  return (
    <section className="auth-screen">
      <div className="auth-panel">
        <div className="auth-brand">
          <img src="/incassaflow-logo.svg" alt={APP_NAME} className="auth-logo" />
          <div>
            <h1>Verifica email</h1>
            <p>Inserisci OTP e conferma indirizzo per attivare l'accesso a {APP_NAME}</p>
          </div>
        </div>

        {!linkValid && <p className="error-text">Link non valido. Apri il link completo ricevuto via email.</p>}
        {status === "loading" && <p>{message}</p>}
        {status === "success" && <p className="success-text">{message}</p>}
        {status === "error" && <p className="error-text">{message}</p>}

        {linkValid && status !== "success" && (
          <form onSubmit={handleSubmit} className="form-grid">
            <label>
              Codice OTP (6 cifre)
              <input
                className="otp-input"
                value={otp}
                onChange={(event) => setOtp(event.target.value.replace(/\D/g, "").slice(0, 6))}
                inputMode="numeric"
                autoComplete="one-time-code"
                placeholder="000000"
                required
              />
            </label>
            <button className="primary-btn" type="submit" disabled={status === "loading"}>
              {status === "loading" ? "Verifica in corso..." : "Conferma email"}
            </button>
          </form>
        )}

        <Link className="primary-btn" to="/auth">
          Vai al login
        </Link>
      </div>
    </section>
  );
}
